export default function Flip() {
  window.addEventListener('load', () => {
    const buttons = document.querySelectorAll(
      '.a-button .a-button__icon-mask svg'
    )
    const buttons_more = document.querySelectorAll(
      '.a-more-info .wrapper__flip__button'
    )

    buttons.forEach((svg) => {
      const svgString = new XMLSerializer().serializeToString(svg)
      const encoded = encodeURIComponent(svgString)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22')

      const styleTarget = svg.closest('.a-button__icon-mask')
      if (styleTarget) {
        styleTarget.style.setProperty(
          '--scroll-icon',
          `url("data:image/svg+xml,${encoded}")`
        )
      }
    })

    buttons_more.forEach((button) => {
      button.setAttribute('data-scroll-text', button.textContent.trim())
      const width = button.querySelector('span').offsetWidth
      button.style.width = `${width}px`
      button.style.minWidth = `revert-layer`
      button.style.maxWidth = `${width}px`
    })
  })
}
